module.exports = __webpack_public_path__ + "img/mono_5.2c6b578e.png";